// extracted by extract-css-chunks-webpack-plugin
module.exports = {"housingMarket":"_1anEEJ"};